<template>
  <div class="learingClassicItems">
    <backHeader back-addr="/indexClassic"></backHeader>
    <div style="height:10px;"></div>
    <ul>
      <div @click="goClassic(item.id)" v-for="item in classicItems" style="text-align:center;margin-left:9px;margin-right:9px;margin-bottom:15px;box-shadow:-2px 0px 2px #C5C8CA,0px -0.5px 0.5px #DFE2E6,2px 0px 2px #C5C8CA,0px 2px 2px #C5C8CA;">
        <p style="text-align:left;margin-bottom:0px;height:35px;background-color:white;padding-left:10px;"><span style="line-height:35px;font-size:16px;">{{ item.name }}</span></p>
        <img :src="item.imgurl" alt="" style="width:100%;"  v-bind:style="{ height: heightSize + 'px' }">
      </div>
    </ul>
  </div>
</template>
<script>
import openUrl from "./../utils/openUrl";
// import IndexApi from '../api/learingInd.js'
import cfg from "./../utils/config";
import axios from "axios";
import Addr from "./../utils/getAPI";
import store from "@/store/index";
import { Toast } from "mint-ui";
import crossLine from "./../components/cross-line.vue";
import backHeader from "./../components/back-header.vue";

export default {
  name: "learingClassicItems",
  data() {
    return {
      isLoadAll: false,
      classicItems: []
    };
  },
  methods: {
    initClassicData() {
      axios
        .get(
          Addr.getGoNewAPIPrefix() +
            "classic/listClassicItem?itemId=" +
            this.$route.query.itemId
        )
        .then(res => {
          if (res.data.returnCode == 100) {
            console.log("res is:");
            console.log(res);
            this.classicItems = res.data.returnData.list;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    goClassic(id) {
      this.$router.push({
        path: "/classic",
        query: {
          id: id,
          itemId:this.$route.query.itemId
        }
      });
    }
  },
  mounted: function() {
    this.initClassicData();
  },
  components: {
    crossLine,
    backHeader
  }
};
</script>

<style lang="scss"  scoped>
@import "../assets/baseScss";
.learingClassicItems {
  font-weight:bold;
  color:rgb(68, 85, 102)!important;
}
</style>



// WEBPACK FOOTER //
// src/module-course/classicItems.vue